import { ApiOrgMarket } from '@kaiizen/kai-pro-api';
import { useNavigate } from 'react-router';

import { PropsCard } from '../Widgets';

export const MarketCard = ({ orgMarket, orgMarketId }: {
  orgMarket: ApiOrgMarket | undefined;
  orgMarketId: string | undefined;
}) => {
  const navigate = useNavigate();

  return (
    <PropsCard
      title='Market Details'
      buttonLabel='View Market'
      onButtonClick={() => navigate(`/market/${orgMarketId}`)}
      items={[
        { label: 'Name', value: orgMarket?.name },
        { label: 'Zip Codes', value: orgMarket?.zipCodes?.join(', ') },
      ]}
    />
  );
};
